module.exports = __webpack_public_path__ + "img/mysql.1a5736ae.png";